import { FC, useState } from 'react'
import {
  Flex,
  Box,
  FormControl,
  Input,
  Stack,
  Button,
  useColorModeValue,
  Text,
  FormErrorMessage,
  InputGroup,
  InputRightElement,
  IconButton,
  Tooltip,
  VStack,
} from '@chakra-ui/react'
import { useFetch } from 'use-http'
import { updateItem } from 'react-use-cookie';
import { useNavigate } from 'react-router';
import { api } from '../../util/api';
import { Logo } from '../../Logo';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import { Ticket } from '../../store/slices/User/reducer';

interface LoginPageProps {
  setToken: updateItem;
  onAccess: (id: number) => void;
}

const LoginPage: FC<LoginPageProps> = ({
  setToken,
  onAccess,
}) => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [loginError, setLoginError] = useState('')
  const [showPassword, setShowPassword] = useState(false);
  const toggleShowPassword = () => setShowPassword(!showPassword);

  const {
    post,
    cache,
    loading,
    error,
    response,
  } = useFetch(`${api}/admin/authenticate`);

  const onChangeEmailHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUsername(e.target.value)
  }

  const onChangePasswordHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value)
  }

  const loginHandler = async () => {
    setLoginError('');
    cache.clear();
    const ticket: Ticket = await post({ username, password });

    if (!response.ok && error) {
      return;
    }

    if (response.status === 401) {
      setLoginError('Usuario y/o contraseña incorrectos.')
      return;
    }

    if (ticket && Object.prototype.hasOwnProperty.call(ticket, 'access_token')) {
      setToken(ticket.access_token, {
        days: 30,
        Secure: true,
      });
      onAccess(ticket.sub);
      navigate('/');
    }
  }

  return (
    <Flex
      minH={'100vh'}
      justify={'center'}
      align={'center'}
      bg={useColorModeValue('gray.50', 'gray.800')}>
      <Stack
        spacing={8}
        mx={'auto'}
        maxW={'lg'}
        py={12}
        px={6}
      >
        <Stack align={'center'}>
          <Logo />
          <Text fontSize="xs" fontWeight='bold' color='gray.500'>
            GUAYMAS
          </Text>
        </Stack>
        <Box
          rounded={'lg'}
          bg={useColorModeValue('white', 'gray.700')}
          boxShadow={'lg'}
          p={8}
        >
          <form>

            <FormControl
              display='flex'
              flexDir='column'
              gap={1}
              isInvalid={!!loginError}
            >
              <VStack align='start' w='full' mb={6} gap={1}>
                <Text fontSize='sm' fontWeight='semibold'>Correo electrónico</Text>
                <Input
                  id='email'
                  type='email'
                  value={username}
                  autoComplete='on'
                  name='email'
                  onChange={onChangeEmailHandler}
                />
              </VStack>
              <VStack align='start' w='full' mb={6} gap={1}>
                <Text fontSize='sm' fontWeight='semibold'>Contraseña</Text>
                <InputGroup size="md">
                  <Input
                    id='password'
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    autoComplete='on'
                    name='password'
                    onChange={onChangePasswordHandler}
                  />
                  <InputRightElement>
                    <Tooltip label={showPassword ? 'Ocultar' : 'Mostrar'}>
                      <IconButton
                        isRound
                        size='sm'
                        aria-label='show password'
                        onClick={toggleShowPassword}
                        variant='ghost'
                      >
                        {showPassword ? <FiEye /> : <FiEyeOff />}
                      </IconButton>
                    </Tooltip>
                  </InputRightElement>
                </InputGroup>
              </VStack>
              <Button
                isDisabled={username === '' || password === ''}
                colorScheme='brand'
                variant='solid'
                onClick={loginHandler}
                isLoading={loading}
              >
                Acceder
              </Button>
              <FormErrorMessage>{loginError}</FormErrorMessage>
            </FormControl>
          </form>
        </Box>
        <Box display='flex' justifyContent='center' userSelect='none'>
          <Text
            color='gray.400'
            fontSize='sm'
          >
            Desarrollado por <Text as='b'>Ludeku</Text>
          </Text>
        </Box>
      </Stack>
    </Flex>
  )
}

export default LoginPage
